import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiService } from "../../api.service";
import { BehaviorSubject, of, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthenticatedDTO } from "../../app.models";
import { RSAHelper } from "./rsa-helper";

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    isAuthenticated = false;
    onUserAuthenticated$ = new BehaviorSubject<boolean>(false);

    constructor(
        private _httpClient: HttpClient, 
        private _apiService: ApiService,
        private _rsaHelper: RSAHelper
    ) {
        this.checkIfUserIsAuthenticated();
    }

    checkIfUserIsAuthenticated() {
        const authSession = this.AuthSession;
        this.isAuthenticated = !!authSession;
        this.onUserAuthenticated$.next(this.isAuthenticated);
    }

    set AuthSession(_session: AuthenticatedDTO | null) { localStorage.setItem(environment.LS_ABWORKFLOW_CORE_API_AUTH_SESSION, _session !== null ? JSON.stringify(_session) : 'null'); }
    get AuthSession(): AuthenticatedDTO | null {
        const lsAuthSessionStr = localStorage.getItem(environment.LS_ABWORKFLOW_CORE_API_AUTH_SESSION);
        if (lsAuthSessionStr === 'undefined' || lsAuthSessionStr === 'null') { return null; }

        let lsAuthSession: AuthenticatedDTO = null;
        try { lsAuthSession = JSON.parse(lsAuthSessionStr); } catch (e) { }
        return lsAuthSession;
    }

    doAuthenticateAction(_username: string, _password: string) {
        return this._httpClient.post(this._apiService.endPoints.Login, { username: this._rsaHelper.encryptWithPublicKey(_username), password: this._rsaHelper.encryptWithPublicKey(_password) })
            .pipe(
                switchMap((_response: AuthenticatedDTO) => {
                    this.AuthSession = _response;
                    this.isAuthenticated = true;
                    this.onUserAuthenticated$.next(true);
                    return of(true);
                }),
                catchError(error => throwError(error.error.Message || 'Une erreur est survenue lors de la requete au serveur'))
            );
    }
    
    doSignOutAction() {
        this.AuthSession = null;
        this.isAuthenticated = false;
        this.onUserAuthenticated$.next(false);

        return of(true);
    }
}
